import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import {
  CHOOSE_WALLET_CREDIT,
  CREDIT_VALIDITY_TEXT,
  RETURN_CASH,
  RETURN_CASH_HEADING,
  RETURN_CREDIT_HEADING,
  SELECTED_REFUND_OPTION,
  SELECT_REFUND_OPTION,
} from '../../config/text/text';
import { symbolFromCurrency } from '../../helpers/currency';
import ThemeContext from '../../providers/ThemeProvider';
import RadioButtonWithLabel from '../_generic/radio-button/RadioButtonWithLabel';

const ReturnsPortalRefundOptions = ({
  isCashRefund,
  returnsPortal,
  currency,
  handleCashRefund,
}) => {
  const theme = useContext(ThemeContext);
  const selectedOption = returnsPortal?.autoRefundType || '';

  return (
    <>
      <div className="returns__refund-options">
        <span>
          {returnsPortal.trackingUrl || selectedOption
            ? SELECTED_REFUND_OPTION
            : SELECT_REFUND_OPTION}{' '}
        </span>
        {(!selectedOption || selectedOption === 'full-credit') && (
          <RadioButtonWithLabel
            checked={!isCashRefund || selectedOption}
            className={classNames(
              'radio-button--switch',
              'radio-button__radio-before-label',
            )}
            disabled={selectedOption}
            label={
              <div className="credit-text">
                <strong>{RETURN_CREDIT_HEADING}</strong>
                {returnsPortal.additionalCreditOffer > 0 && (
                  <span className="credit-text--green">
                    {CHOOSE_WALLET_CREDIT}{' '}
                    <strong>
                      additional {symbolFromCurrency(currency)}
                      {returnsPortal.additionalCreditOffer} credit
                    </strong>
                  </span>
                )}
                <span className="credit-validity">{CREDIT_VALIDITY_TEXT}</span>
              </div>
            }
            onChange={handleCashRefund}
          />
        )}
        {(!selectedOption || selectedOption === 'original-payment-source') &&
          returnsPortal?.eligibleForCashRefund && (
            <RadioButtonWithLabel
              checked={isCashRefund || selectedOption}
              className={classNames(
                'radio-button--switch',
                'radio-button__radio-before-label',
              )}
              disabled={selectedOption}
              label={
                <div className="credit-text">
                  <strong>{RETURN_CASH}</strong>
                  <span>{RETURN_CASH_HEADING}</span>
                </div>
              }
              onChange={handleCashRefund}
            />
          )}
      </div>

      <style jsx>{`
        .returns__refund-options {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .credit-text {
          display: flex;
          flex-direction: column;
          text-align: start;
          font-weight: 400;
        }

        .credit-text--green {
          color: ${theme.colors.successboxborder};
        }
      `}</style>
    </>
  );
};

ReturnsPortalRefundOptions.propTypes = {
  currency: PropTypes.string.isRequired,
  handleCashRefund: PropTypes.func.isRequired,
  isCashRefund: PropTypes.bool,
  returnsPortal: PropTypes.object.isRequired,
};

export default ReturnsPortalRefundOptions;
